import { render, staticRenderFns } from "./MrTaskManagementList.vue?vue&type=template&id=b7996ee6&"
import script from "./MrTaskManagementList.vue?vue&type=script&lang=js&"
export * from "./MrTaskManagementList.vue?vue&type=script&lang=js&"
import style0 from "./MrTaskManagementList.vue?vue&type=style&index=0&id=b7996ee6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports